import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelSelect as _vModelSelect, createCommentVNode as _createCommentVNode, createVNode as _createVNode, vModelCheckbox as _vModelCheckbox, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "tab-content" }
const _hoisted_2 = {
  class: "tab-pane fade show active",
  id: "basic-info",
  role: "tabpanel"
}
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-8" }
const _hoisted_5 = { class: "mb-3" }
const _hoisted_6 = { class: "form-text" }
const _hoisted_7 = { class: "mb-3" }
const _hoisted_8 = { class: "mb-3" }
const _hoisted_9 = { class: "form-text" }
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "mb-3" }
const _hoisted_12 = ["value"]
const _hoisted_13 = { class: "mb-3" }
const _hoisted_14 = {
  key: 0,
  class: "mt-2"
}
const _hoisted_15 = ["onClick"]
const _hoisted_16 = { class: "mb-3" }
const _hoisted_17 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_18 = {
  class: "tab-pane fade",
  id: "content",
  role: "tabpanel"
}
const _hoisted_19 = { class: "mb-3" }
const _hoisted_20 = {
  class: "tab-pane fade",
  id: "media",
  role: "tabpanel"
}
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = { class: "mb-3" }
const _hoisted_24 = { class: "mb-3" }
const _hoisted_25 = { class: "mb-3" }
const _hoisted_26 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_27 = ["src", "alt"]
const _hoisted_28 = { class: "col-md-6" }
const _hoisted_29 = { class: "mb-3" }
const _hoisted_30 = { class: "gallery-images mt-3" }
const _hoisted_31 = ["src", "alt"]
const _hoisted_32 = { class: "flex-grow-1" }
const _hoisted_33 = ["onUpdate:modelValue"]
const _hoisted_34 = ["onUpdate:modelValue"]
const _hoisted_35 = ["onClick"]
const _hoisted_36 = {
  class: "tab-pane fade",
  id: "seo",
  role: "tabpanel"
}
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "col-md-6" }
const _hoisted_39 = { class: "mb-3" }
const _hoisted_40 = { class: "form-text" }
const _hoisted_41 = { class: "mb-3" }
const _hoisted_42 = { class: "form-text" }
const _hoisted_43 = { class: "mb-3" }
const _hoisted_44 = { class: "mb-3" }
const _hoisted_45 = { class: "col-md-6" }
const _hoisted_46 = { class: "mb-3" }
const _hoisted_47 = { class: "mb-3" }
const _hoisted_48 = { class: "mb-3" }
const _hoisted_49 = { class: "mb-3" }
const _hoisted_50 = { class: "mb-3" }
const _hoisted_51 = { class: "mb-3" }
const _hoisted_52 = {
  class: "tab-pane fade",
  id: "settings",
  role: "tabpanel"
}
const _hoisted_53 = { class: "row" }
const _hoisted_54 = { class: "col-md-6" }
const _hoisted_55 = { class: "form-check form-switch mb-3" }
const _hoisted_56 = { class: "form-check form-switch mb-3" }
const _hoisted_57 = { class: "form-check form-switch mb-3" }
const _hoisted_58 = { class: "form-check form-switch mb-3" }
const _hoisted_59 = { class: "col-md-6" }
const _hoisted_60 = { class: "mb-3" }
const _hoisted_61 = { class: "mb-3" }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-4" }
const _hoisted_64 = { class: "fw-bold" }
const _hoisted_65 = { class: "col-4" }
const _hoisted_66 = { class: "fw-bold" }
const _hoisted_67 = { class: "col-4" }
const _hoisted_68 = { class: "fw-bold" }
const _hoisted_69 = { class: "d-flex justify-content-end gap-2 mt-4 pt-3 border-top" }
const _hoisted_70 = ["disabled"]
const _hoisted_71 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

import { ref, reactive, computed, watch, onMounted } from "vue";
import apiService from "@/services/apiService";
import RichTextEditor from "@/components/commen/RichTextEditor.vue";

// Props
interface Props {
  blog?: any;
  categories: any[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'BlogForm',
  props: {
    blog: { default: null },
    categories: { default: () => [] }
  },
  emits: ["save", "cancel"],
  setup(__props: any, { expose: __expose, emit: __emit }) {

const props = __props;

// Emits
const emit = __emit;

// State
const loading = ref(false);
const tagsInput = ref("");
const metaKeywordsInput = ref("");
const scheduledAtInput = ref("");

// Form data
const formData = reactive({
  title: "",
  slug: "",
  excerpt: "",
  content: "",
  featured_image: "",
  featured_image_alt: "",
  gallery_images: [] as Array<{ url: string; alt: string; caption: string }>,
  category_id: "",
  tags: [] as string[],
  status: "draft",
  published_at: "",
  scheduled_at: "",
  reading_time: 0,
  is_featured: false,
  is_trending: false,
  allow_comments: true,
  meta_title: "",
  meta_description: "",
  meta_keywords: [] as string[],
  canonical_url: "",
  og_title: "",
  og_description: "",
  og_image: "",
  twitter_title: "",
  twitter_description: "",
  twitter_image: "",
  is_active: true,
  view_count: 0,
  like_count: 0,
  share_count: 0,
});

// Computed
const isEdit = computed(() => !!props.blog?._id);

// Methods
const generateSlug = () => {
  if (formData.title && !isEdit.value) {
    formData.slug = formData.title
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, "-")
      .replace(/(^-|-$)/g, "");
  }
};

const onFeaturedImageSelect = async (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    try {
      loading.value = true;
      const response = await apiService.uploadFile("upload/file-common", file);
      formData.featured_image = response.url;
    } catch (error) {
      console.error("Error uploading featured image:", error);
      alert("Error uploading image. Please try again.");
    } finally {
      loading.value = false;
    }
  }
};

const onGalleryImageSelect = async (event: Event) => {
  const file = (event.target as HTMLInputElement).files?.[0];
  if (file) {
    try {
      loading.value = true;
      const response = await apiService.uploadFile("upload/file-common", file);
      formData.gallery_images.push({
        url: response.url,
        alt: "",
        caption: "",
      });
      // Reset the input
      (event.target as HTMLInputElement).value = "";
    } catch (error) {
      console.error("Error uploading gallery image:", error);
      alert("Error uploading image. Please try again.");
    } finally {
      loading.value = false;
    }
  }
};

const removeGalleryImage = (index: number) => {
  formData.gallery_images.splice(index, 1);
};

const removeTag = (index: number) => {
  formData.tags.splice(index, 1);
  updateTagsInput();
};

const updateTagsInput = () => {
  tagsInput.value = formData.tags.join(", ");
};

const updateMetaKeywordsInput = () => {
  metaKeywordsInput.value = formData.meta_keywords.join(", ");
};

const handleSubmit = async () => {
  try {
    loading.value = true;

    // Process tags
    if (tagsInput.value) {
      formData.tags = tagsInput.value
        .split(",")
        .map((tag) => tag.trim().toLowerCase())
        .filter((tag) => tag.length > 0);
    }

    // Process meta keywords
    if (metaKeywordsInput.value) {
      formData.meta_keywords = metaKeywordsInput.value
        .split(",")
        .map((keyword) => keyword.trim())
        .filter((keyword) => keyword.length > 0);
    }

    // Process scheduled date
    if (scheduledAtInput.value) {
      formData.scheduled_at = new Date(scheduledAtInput.value).toISOString();
    }

    emit("save", { ...formData });
  } catch (error) {
    console.error("Error preparing blog data:", error);
  } finally {
    loading.value = false;
  }
};

// Initialize form data when blog prop changes
watch(
  () => props.blog,
  (newBlog) => {
    if (newBlog) {
      // Map basic fields
      Object.assign(formData, {
        ...newBlog,
        // Extract ID if category_id is an object
        category_id: typeof newBlog.category_id === 'object' && newBlog.category_id !== null
          ? newBlog.category_id._id 
          : newBlog.category_id || "",
        gallery_images: Array.isArray(newBlog.gallery_images) ? [...newBlog.gallery_images] : [],
        tags: Array.isArray(newBlog.tags) ? [...newBlog.tags] : [],
        meta_keywords: Array.isArray(newBlog.meta_keywords) ? [...newBlog.meta_keywords] : [],
      });

      // Update input fields for tags and keywords
      updateTagsInput();
      updateMetaKeywordsInput();

      // Handle scheduled_at input
      if (newBlog.scheduled_at) {
        try {
          scheduledAtInput.value = new Date(newBlog.scheduled_at)
            .toISOString()
            .slice(0, 16);
        } catch (e) {
          console.error("Invalid scheduled date:", newBlog.scheduled_at);
          scheduledAtInput.value = "";
        }
      } else {
        scheduledAtInput.value = "";
      }
    }
  },
  { immediate: true }
);

// Expose methods to parent components
__expose({
  handleSubmit,
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("form", {
    onSubmit: _withModifiers(handleSubmit, ["prevent"])
  }, [
    _cache[68] || (_cache[68] = _createElementVNode("ul", {
      class: "nav nav-tabs mb-4",
      role: "tablist"
    }, [
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link active",
          type: "button",
          "data-bs-toggle": "tab",
          "data-bs-target": "#basic-info",
          role: "tab"
        }, [
          _createElementVNode("i", { class: "fas fa-info-circle me-1" }),
          _createTextVNode(" Basic Info ")
        ])
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          type: "button",
          "data-bs-toggle": "tab",
          "data-bs-target": "#content",
          role: "tab"
        }, [
          _createElementVNode("i", { class: "fas fa-file-text me-1" }),
          _createTextVNode(" Content ")
        ])
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          type: "button",
          "data-bs-toggle": "tab",
          "data-bs-target": "#media",
          role: "tab"
        }, [
          _createElementVNode("i", { class: "fas fa-images me-1" }),
          _createTextVNode(" Media ")
        ])
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          type: "button",
          "data-bs-toggle": "tab",
          "data-bs-target": "#seo",
          role: "tab"
        }, [
          _createElementVNode("i", { class: "fas fa-search me-1" }),
          _createTextVNode(" SEO & Social ")
        ])
      ]),
      _createElementVNode("li", {
        class: "nav-item",
        role: "presentation"
      }, [
        _createElementVNode("button", {
          class: "nav-link",
          type: "button",
          "data-bs-toggle": "tab",
          "data-bs-target": "#settings",
          role: "tab"
        }, [
          _createElementVNode("i", { class: "fas fa-cog me-1" }),
          _createTextVNode(" Settings ")
        ])
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _cache[26] || (_cache[26] = _createElementVNode("label", {
                for: "title",
                class: "form-label required"
              }, "Blog Title", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "title",
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((formData.title) = $event)),
                onInput: generateSlug,
                required: "",
                maxlength: "200"
              }, null, 544), [
                [_vModelText, formData.title]
              ]),
              _createElementVNode("div", _hoisted_6, _toDisplayString(formData.title?.length || 0) + "/200 characters ", 1)
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[27] || (_cache[27] = _createElementVNode("label", {
                for: "slug",
                class: "form-label required"
              }, "Slug", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "slug",
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formData.slug) = $event)),
                required: "",
                pattern: "^[a-z0-9-]+$",
                title: "Only lowercase letters, numbers, and hyphens are allowed"
              }, null, 512), [
                [_vModelText, formData.slug]
              ]),
              _cache[28] || (_cache[28] = _createElementVNode("div", { class: "form-text" }, " URL-friendly version of the title (lowercase, hyphens only) ", -1))
            ]),
            _createElementVNode("div", _hoisted_8, [
              _cache[29] || (_cache[29] = _createElementVNode("label", {
                for: "excerpt",
                class: "form-label"
              }, "Excerpt", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                id: "excerpt",
                "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((formData.excerpt) = $event)),
                rows: "3",
                maxlength: "300",
                placeholder: "Brief description of the blog post..."
              }, null, 512), [
                [_vModelText, formData.excerpt]
              ]),
              _createElementVNode("div", _hoisted_9, _toDisplayString(formData.excerpt?.length || 0) + "/300 characters ", 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("div", _hoisted_11, [
              _cache[31] || (_cache[31] = _createElementVNode("label", {
                for: "category_id",
                class: "form-label required"
              }, "Category", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                id: "category_id",
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formData.category_id) = $event)),
                required: ""
              }, [
                _cache[30] || (_cache[30] = _createElementVNode("option", { value: "" }, "Select Category", -1)),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.categories, (category) => {
                  return (_openBlock(), _createElementBlock("option", {
                    key: category._id,
                    value: category._id
                  }, _toDisplayString(category.title), 9, _hoisted_12))
                }), 128))
              ], 512), [
                [_vModelSelect, formData.category_id]
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _cache[32] || (_cache[32] = _createElementVNode("label", {
                for: "tags",
                class: "form-label"
              }, "Tags", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "tags",
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((tagsInput).value = $event)),
                placeholder: "Enter tags separated by commas"
              }, null, 512), [
                [_vModelText, tagsInput.value]
              ]),
              _cache[33] || (_cache[33] = _createElementVNode("div", { class: "form-text" }, "Separate multiple tags with commas", -1)),
              (formData.tags && formData.tags.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.tags, (tag, index) => {
                      return (_openBlock(), _createElementBlock("span", {
                        key: index,
                        class: "badge bg-secondary me-1 mb-1"
                      }, [
                        _createTextVNode(_toDisplayString(tag) + " ", 1),
                        _createElementVNode("button", {
                          type: "button",
                          class: "btn-close btn-close-white ms-1",
                          onClick: ($event: any) => (removeTag(index)),
                          style: {"font-size":"0.7em"}
                        }, null, 8, _hoisted_15)
                      ]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", _hoisted_16, [
              _cache[35] || (_cache[35] = _createElementVNode("label", {
                for: "status",
                class: "form-label"
              }, "Status", -1)),
              _withDirectives(_createElementVNode("select", {
                class: "form-select",
                id: "status",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formData.status) = $event))
              }, [...(_cache[34] || (_cache[34] = [
                _createElementVNode("option", { value: "draft" }, "Draft", -1),
                _createElementVNode("option", { value: "published" }, "Published", -1),
                _createElementVNode("option", { value: "scheduled" }, "Scheduled", -1),
                _createElementVNode("option", { value: "archived" }, "Archived", -1)
              ]))], 512), [
                [_vModelSelect, formData.status]
              ])
            ]),
            (formData.status === 'scheduled')
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[36] || (_cache[36] = _createElementVNode("label", {
                    for: "scheduled_at",
                    class: "form-label"
                  }, "Schedule Date", -1)),
                  _withDirectives(_createElementVNode("input", {
                    type: "datetime-local",
                    class: "form-control",
                    id: "scheduled_at",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((scheduledAtInput).value = $event))
                  }, null, 512), [
                    [_vModelText, scheduledAtInput.value]
                  ])
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_18, [
        _createElementVNode("div", _hoisted_19, [
          _cache[37] || (_cache[37] = _createElementVNode("label", {
            for: "content",
            class: "form-label required"
          }, "Blog Content", -1)),
          _createVNode(RichTextEditor, {
            modelValue: formData.content,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formData.content) = $event)),
            placeholder: "Write your blog content here...",
            height: "400px"
          }, null, 8, ["modelValue"]),
          _cache[38] || (_cache[38] = _createElementVNode("div", { class: "form-text" }, " Use the rich text editor to format your content. Reading time will be calculated automatically. ", -1))
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("div", _hoisted_22, [
            _cache[42] || (_cache[42] = _createElementVNode("h6", null, "Featured Image", -1)),
            _createElementVNode("div", _hoisted_23, [
              _cache[39] || (_cache[39] = _createElementVNode("label", {
                for: "featured_image_file",
                class: "form-label"
              }, "Upload Featured Image", -1)),
              _createElementVNode("input", {
                type: "file",
                class: "form-control",
                id: "featured_image_file",
                onChange: onFeaturedImageSelect,
                accept: "image/*"
              }, null, 32)
            ]),
            _createElementVNode("div", _hoisted_24, [
              _cache[40] || (_cache[40] = _createElementVNode("label", {
                for: "featured_image_url",
                class: "form-label"
              }, "Or Enter Image URL", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "url",
                class: "form-control",
                id: "featured_image_url",
                "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formData.featured_image) = $event)),
                placeholder: "https://example.com/image.jpg"
              }, null, 512), [
                [_vModelText, formData.featured_image]
              ])
            ]),
            _createElementVNode("div", _hoisted_25, [
              _cache[41] || (_cache[41] = _createElementVNode("label", {
                for: "featured_image_alt",
                class: "form-label"
              }, "Alt Text", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "featured_image_alt",
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formData.featured_image_alt) = $event)),
                maxlength: "100",
                placeholder: "Describe the image for accessibility"
              }, null, 512), [
                [_vModelText, formData.featured_image_alt]
              ])
            ]),
            (formData.featured_image)
              ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                  _createElementVNode("img", {
                    src: formData.featured_image,
                    alt: formData.featured_image_alt,
                    class: "img-thumbnail",
                    style: {"max-width":"200px","max-height":"150px"}
                  }, null, 8, _hoisted_27)
                ]))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_28, [
            _cache[45] || (_cache[45] = _createElementVNode("h6", null, "Gallery Images", -1)),
            _createElementVNode("div", _hoisted_29, [
              _cache[43] || (_cache[43] = _createElementVNode("label", {
                for: "gallery_image_file",
                class: "form-label"
              }, "Upload Gallery Image", -1)),
              _createElementVNode("input", {
                type: "file",
                class: "form-control",
                id: "gallery_image_file",
                onChange: onGalleryImageSelect,
                accept: "image/*"
              }, null, 32)
            ]),
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(formData.gallery_images, (image, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "d-flex align-items-start mb-3 p-2 border rounded"
                }, [
                  _createElementVNode("img", {
                    src: image.url,
                    alt: image.alt,
                    class: "img-thumbnail me-3",
                    style: {"width":"80px","height":"60px","object-fit":"cover"}
                  }, null, 8, _hoisted_31),
                  _createElementVNode("div", _hoisted_32, [
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm mb-2",
                      "onUpdate:modelValue": ($event: any) => ((image.alt) = $event),
                      placeholder: "Alt text",
                      maxlength: "100"
                    }, null, 8, _hoisted_33), [
                      [_vModelText, image.alt]
                    ]),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "form-control form-control-sm",
                      "onUpdate:modelValue": ($event: any) => ((image.caption) = $event),
                      placeholder: "Caption",
                      maxlength: "200"
                    }, null, 8, _hoisted_34), [
                      [_vModelText, image.caption]
                    ])
                  ]),
                  _createElementVNode("button", {
                    type: "button",
                    class: "btn btn-sm btn-outline-danger ms-2",
                    onClick: ($event: any) => (removeGalleryImage(index))
                  }, [...(_cache[44] || (_cache[44] = [
                    _createElementVNode("i", { class: "fas fa-trash" }, null, -1)
                  ]))], 8, _hoisted_35)
                ]))
              }), 128))
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _cache[50] || (_cache[50] = _createElementVNode("h6", null, "Search Engine Optimization", -1)),
            _createElementVNode("div", _hoisted_39, [
              _cache[46] || (_cache[46] = _createElementVNode("label", {
                for: "meta_title",
                class: "form-label"
              }, "Meta Title", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "meta_title",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formData.meta_title) = $event)),
                maxlength: "60",
                placeholder: "SEO title for search engines"
              }, null, 512), [
                [_vModelText, formData.meta_title]
              ]),
              _createElementVNode("div", _hoisted_40, _toDisplayString(formData.meta_title?.length || 0) + "/60 characters ", 1)
            ]),
            _createElementVNode("div", _hoisted_41, [
              _cache[47] || (_cache[47] = _createElementVNode("label", {
                for: "meta_description",
                class: "form-label"
              }, "Meta Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                id: "meta_description",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((formData.meta_description) = $event)),
                rows: "3",
                maxlength: "160",
                placeholder: "Description for search engine results"
              }, null, 512), [
                [_vModelText, formData.meta_description]
              ]),
              _createElementVNode("div", _hoisted_42, _toDisplayString(formData.meta_description?.length || 0) + "/160 characters ", 1)
            ]),
            _createElementVNode("div", _hoisted_43, [
              _cache[48] || (_cache[48] = _createElementVNode("label", {
                for: "meta_keywords",
                class: "form-label"
              }, "Meta Keywords", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "meta_keywords",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((metaKeywordsInput).value = $event)),
                placeholder: "keyword1, keyword2, keyword3"
              }, null, 512), [
                [_vModelText, metaKeywordsInput.value]
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _cache[49] || (_cache[49] = _createElementVNode("label", {
                for: "canonical_url",
                class: "form-label"
              }, "Canonical URL", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "url",
                class: "form-control",
                id: "canonical_url",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((formData.canonical_url) = $event)),
                placeholder: "https://example.com/canonical-url"
              }, null, 512), [
                [_vModelText, formData.canonical_url]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_45, [
            _cache[57] || (_cache[57] = _createElementVNode("h6", null, "Social Media", -1)),
            _createElementVNode("div", _hoisted_46, [
              _cache[51] || (_cache[51] = _createElementVNode("label", {
                for: "og_title",
                class: "form-label"
              }, "Open Graph Title", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "og_title",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((formData.og_title) = $event)),
                maxlength: "60",
                placeholder: "Title for social media sharing"
              }, null, 512), [
                [_vModelText, formData.og_title]
              ])
            ]),
            _createElementVNode("div", _hoisted_47, [
              _cache[52] || (_cache[52] = _createElementVNode("label", {
                for: "og_description",
                class: "form-label"
              }, "Open Graph Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                id: "og_description",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((formData.og_description) = $event)),
                rows: "3",
                maxlength: "160",
                placeholder: "Description for social media sharing"
              }, null, 512), [
                [_vModelText, formData.og_description]
              ])
            ]),
            _createElementVNode("div", _hoisted_48, [
              _cache[53] || (_cache[53] = _createElementVNode("label", {
                for: "og_image",
                class: "form-label"
              }, "Open Graph Image", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "url",
                class: "form-control",
                id: "og_image",
                "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((formData.og_image) = $event)),
                placeholder: "https://example.com/og-image.jpg"
              }, null, 512), [
                [_vModelText, formData.og_image]
              ])
            ]),
            _createElementVNode("div", _hoisted_49, [
              _cache[54] || (_cache[54] = _createElementVNode("label", {
                for: "twitter_title",
                class: "form-label"
              }, "Twitter Title", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "text",
                class: "form-control",
                id: "twitter_title",
                "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((formData.twitter_title) = $event)),
                maxlength: "60",
                placeholder: "Title for Twitter sharing"
              }, null, 512), [
                [_vModelText, formData.twitter_title]
              ])
            ]),
            _createElementVNode("div", _hoisted_50, [
              _cache[55] || (_cache[55] = _createElementVNode("label", {
                for: "twitter_description",
                class: "form-label"
              }, "Twitter Description", -1)),
              _withDirectives(_createElementVNode("textarea", {
                class: "form-control",
                id: "twitter_description",
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((formData.twitter_description) = $event)),
                rows: "3",
                maxlength: "160",
                placeholder: "Description for Twitter sharing"
              }, null, 512), [
                [_vModelText, formData.twitter_description]
              ])
            ]),
            _createElementVNode("div", _hoisted_51, [
              _cache[56] || (_cache[56] = _createElementVNode("label", {
                for: "twitter_image",
                class: "form-label"
              }, "Twitter Image", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "url",
                class: "form-control",
                id: "twitter_image",
                "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((formData.twitter_image) = $event)),
                placeholder: "https://example.com/twitter-image.jpg"
              }, null, 512), [
                [_vModelText, formData.twitter_image]
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_52, [
        _createElementVNode("div", _hoisted_53, [
          _createElementVNode("div", _hoisted_54, [
            _createElementVNode("div", _hoisted_55, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "is_featured",
                "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((formData.is_featured) = $event))
              }, null, 512), [
                [_vModelCheckbox, formData.is_featured]
              ]),
              _cache[58] || (_cache[58] = _createElementVNode("label", {
                class: "form-check-label",
                for: "is_featured"
              }, " Featured Blog ", -1))
            ]),
            _createElementVNode("div", _hoisted_56, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "is_trending",
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((formData.is_trending) = $event))
              }, null, 512), [
                [_vModelCheckbox, formData.is_trending]
              ]),
              _cache[59] || (_cache[59] = _createElementVNode("label", {
                class: "form-check-label",
                for: "is_trending"
              }, " Trending Blog ", -1))
            ]),
            _createElementVNode("div", _hoisted_57, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "allow_comments",
                "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((formData.allow_comments) = $event))
              }, null, 512), [
                [_vModelCheckbox, formData.allow_comments]
              ]),
              _cache[60] || (_cache[60] = _createElementVNode("label", {
                class: "form-check-label",
                for: "allow_comments"
              }, " Allow Comments ", -1))
            ]),
            _createElementVNode("div", _hoisted_58, [
              _withDirectives(_createElementVNode("input", {
                class: "form-check-input",
                type: "checkbox",
                id: "is_active",
                "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((formData.is_active) = $event))
              }, null, 512), [
                [_vModelCheckbox, formData.is_active]
              ]),
              _cache[61] || (_cache[61] = _createElementVNode("label", {
                class: "form-check-label",
                for: "is_active"
              }, " Active ", -1))
            ])
          ]),
          _createElementVNode("div", _hoisted_59, [
            _createElementVNode("div", _hoisted_60, [
              _cache[62] || (_cache[62] = _createElementVNode("label", {
                for: "reading_time",
                class: "form-label"
              }, "Reading Time (minutes)", -1)),
              _withDirectives(_createElementVNode("input", {
                type: "number",
                class: "form-control",
                id: "reading_time",
                "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((formData.reading_time) = $event)),
                min: "1",
                placeholder: "Will be calculated automatically"
              }, null, 512), [
                [
                  _vModelText,
                  formData.reading_time,
                  void 0,
                  { number: true }
                ]
              ]),
              _cache[63] || (_cache[63] = _createElementVNode("div", { class: "form-text" }, " Leave empty for automatic calculation based on content length ", -1))
            ]),
            _createElementVNode("div", _hoisted_61, [
              _cache[67] || (_cache[67] = _createElementVNode("label", { class: "form-label" }, "Statistics (Read-only)", -1)),
              _createElementVNode("div", _hoisted_62, [
                _createElementVNode("div", _hoisted_63, [
                  _cache[64] || (_cache[64] = _createElementVNode("small", { class: "text-muted" }, "Views", -1)),
                  _createElementVNode("div", _hoisted_64, _toDisplayString(formData.view_count || 0), 1)
                ]),
                _createElementVNode("div", _hoisted_65, [
                  _cache[65] || (_cache[65] = _createElementVNode("small", { class: "text-muted" }, "Likes", -1)),
                  _createElementVNode("div", _hoisted_66, _toDisplayString(formData.like_count || 0), 1)
                ]),
                _createElementVNode("div", _hoisted_67, [
                  _cache[66] || (_cache[66] = _createElementVNode("small", { class: "text-muted" }, "Shares", -1)),
                  _createElementVNode("div", _hoisted_68, _toDisplayString(formData.share_count || 0), 1)
                ])
              ])
            ])
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_69, [
      _createElementVNode("button", {
        type: "button",
        class: "btn btn-secondary",
        onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.$emit('cancel')))
      }, " Cancel "),
      _createElementVNode("button", {
        type: "submit",
        class: "btn btn-primary",
        disabled: loading.value
      }, [
        (loading.value)
          ? (_openBlock(), _createElementBlock("span", _hoisted_71))
          : _createCommentVNode("", true),
        _createTextVNode(" " + _toDisplayString(isEdit.value ? "Update Blog" : "Create Blog"), 1)
      ], 8, _hoisted_70)
    ])
  ], 32))
}
}

})